import { Component, OnInit } from '@angular/core';
import { BooleanCheckOrCrossViewColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-void-reasons',
    templateUrl: './void-reasons.component.html',
    styleUrls: ['./void-reasons.component.scss'],
    standalone: false
})
export class VoidReasonsComponent implements OnInit {

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn('Id', 'Id'),
    new Datalistviewcolumn('Text', 'Text'),
    new BooleanCheckOrCrossViewColumn('Counts Against Performance', 'CountsAgainstPerformance'),
    new BooleanCheckOrCrossViewColumn('Publicly Visible', 'PubliclyVisible')
  ];

  constructor() { }

  async ngOnInit(): Promise<void> {
  }
}

